import { render, staticRenderFns } from "./BarTDWidget.vue?vue&type=template&id=62346293&scoped=true"
import script from "./BarTDWidget.vue?vue&type=script&lang=js"
export * from "./BarTDWidget.vue?vue&type=script&lang=js"
import style0 from "./BarTDWidget.vue?vue&type=style&index=0&id=62346293&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62346293",
  null
  
)

export default component.exports